import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AlertButtonColor, AlertButtonStyle } from "@obg/mat.ui.core";
import { AbstractTranslatableAlertService, SessionLimitInfoResponse } from "@obg/ngx.core";
import { fromMillisecondsToMinutes } from "@obg/ngx.global";
import { SessionLimitsAlertContainer } from "@obg/ngx.ui.common";

import { RealTimeNotificationsConfig } from "../real-time-notifications/real-time-notifications.config";

import { CustomerLimitNotificationsAction } from "./customer-limit-notifications.actions";
import { SessionLimitNotificationPayload, SESSION_LIMIT_REMINDER_ALERT_ID } from "./customer-limit-notifications.model";

@Injectable({
	providedIn: "root",
})
export class SessionLimitNotificationService {
	constructor(
		private store: Store,
		private alertService: AbstractTranslatableAlertService,
		private realTimeNotificationsConfig: RealTimeNotificationsConfig
	) {}

	openSessionLimitReminderAlert$(data: SessionLimitNotificationPayload) {
		return this.alertService.open$(
			{
				id: SESSION_LIMIT_REMINDER_ALERT_ID,
				hideClose: true,
				messageComponent: SessionLimitsAlertContainer,
				messageComponentInit: (component: SessionLimitsAlertContainer) => {
					component.data = data;
				},
				dialogConfig: {
					closeOnNavigation: false,
					panelClass: "session-limits-alert",
				},
				buttons: [
					{
						text: "general.close",
						style: AlertButtonStyle.Flat,
						color: AlertButtonColor.Accent,
					},
				],
			},
			[]
		);
	}

	checkRemainingSessionLimit(limitsSummary: SessionLimitInfoResponse) {
		if (!this.realTimeNotificationsConfig.getPostLoginLimitCheckEnabled()) {
			return;
		}

		const SESSION_NOTIFICATION_TIME_RANGE = 15;
		if (fromMillisecondsToMinutes(limitsSummary.remainingSessionTime) > SESSION_NOTIFICATION_TIME_RANGE) {
			return;
		}

		this.store.dispatch(
			CustomerLimitNotificationsAction.openSessionLimitNotificationDialog({
				usedSessionTimeInMillis: limitsSummary.usedSessionTimeLimit,
				remainingSessionTimeInMillis: limitsSummary.remainingSessionTime,
			})
		);
	}
}
